<template>
    <modal
        :show="show"
        :max-width="maxWidth"
        :closeable="closeable"
        :position="position"
        :otherClasses="otherClasses"
        @close="close"
    >
        <div :id="id">
            <div class="px-6 py-4">
                <div class="text-lg">
                    <slot name="title" />
                    <button
                        v-if="closeIcon"
                        content="Fechar"
                        class="text-sm text-gray-400 absolute right-4 top-3"
                        @click="close"
                    >
                        <i class="p-2 fa-1_5x fas fa-times"></i>
                    </button>
                </div>

                <div class="mt-4">
                    <slot name="content">
                    </slot>
                </div>
            </div>

            <div v-if="noFooter === false" class="px-6 py-4 bg-gray-100 text-right rounded-lg">
                <slot name="footer">
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from './Modal'

    export default {
        components: {
            Modal,
        },

        props: {
            show: {
                default: false
            },
            maxWidth: {
                default: '2xl'
            },
            closeable: {
                default: true
            },
            id: {
                default: 'modal'
            },
            position: {
                default: 'absolute'
            },
            noFooter: {
                default: false
            },
            closeIcon: {
                default: false
            },
            otherClasses: {
                default: ''
            }
        },

        methods: {
            close() {
                this.$emit('close')
            },
        }
    }
</script>
